import * as React from 'react';
import { CartItem, Cart } from 'Core/Api/Kopp/Api';
import { List, Button, Collapse, Row, Col, message, Table, Tooltip, Icon, Popover } from 'antd';
import { BorderlessCollapse } from 'components/Styled/Layout.Styled';
import moment, { Moment } from 'moment';
import { CargesModel } from 'components/CargoCharges/CargoChargesResults/CargoChargesResultsModel';
import { ColumnProps } from 'antd/lib/table';
import { CartHandler } from '../CartHandler';
import { CargoChargesHandler } from 'components/CargoCharges/CargoChargesForm/CargoChargesFormHandler';
import { CargoChargeItemHandler } from 'components/CargoCharges/CargoChargesResults/CargoChargeItem/CargoChargeItemHandler';
import Utility from 'Core/Utility';
import { CartItemChangeDateForm } from '.';
import NotificationUtility from 'Core/NotificationUtility';
import ConfigUtility from 'Core/ConfigUtility';
import styled from "styled-components";

export interface Props {
  cartItem: CartItem;
  updateCart(cart?: Cart);
}

export interface State {
  cartItem?: CartItem;
  updating: boolean;
  isRemoved?: boolean;
}

export default class CartItemListItem extends React.Component<Props, State> {
  handler: CartHandler;
  config = ConfigUtility.getSync();

  cargoChargesHandler: CargoChargesHandler;
  cargoChargeItemHandler: CargoChargeItemHandler;
  constructor(props: Props) {
    super(props);
    this.handler = new CartHandler(props);
    this.cargoChargesHandler = new CargoChargesHandler(props);
    this.cargoChargeItemHandler = new CargoChargeItemHandler(props);
    const cartItem = props.cartItem;
    this.state = { cartItem, updating: false };
    this.updateCartItemDate = this.updateCartItemDate.bind(this);
  }

  chargeTableColums: Array<ColumnProps<CargesModel>> = [
    {
      title: 'Charge',
      dataIndex: 'chargeType',
      key: 'chargeType',
    },
    {
      title: 'Amount',
      dataIndex: 'chargeAmount',
      key: 'chargeAmount',
    },
  ];

  componentDidMount() {
    this.UpdateCartItemIfStale(this.props.cartItem);
  }

  UpdateCartItemIfStale(cartItem: CartItem) {
    // Will always check cart item on coming to page.
    this.UpdateCartItem(cartItem);

  }

  private UpdateCartItem(cartItem: CartItem) {
    const pickupDate = moment.parseZone(cartItem.pickupDate);
    if (pickupDate.isBefore(moment.now(), 'day')) {
      cartItem.pickupDate = Utility.ConvertToStandardTimezone(moment()).toISOString(true);
    }
    this.setState({ updating: true });
    const me = this; // ensuring that we don't lose what this is
    // since we are going to nest twice
    // We are going to search for the bol charges then (if successful),
    // update the cart on the server with it then (if successful) update
    // or client with it..
    const bolSearch = { bolNumber: cartItem.itemReference!, storageToDate: moment.parseZone(cartItem.pickupDate) };
    return this.cargoChargesHandler
      .GetBillOfLadingCharges(bolSearch)
      .then(cargoChargesResults => {

        if (cargoChargesResults.total == 0) {
          me.removeFromCart(me.props.cartItem, false);
          NotificationUtility.info("Cart Item Removed", "Item that was in cart has no charge and was removed");
          this.setState({ updating: false });
        }

        // while getting information, I have been removed
        if (this.state.isRemoved) { return; }

        me.cargoChargeItemHandler
          .UpsertToCart(cargoChargesResults)
          .then(cartResult => {
            this.props.updateCart(cartResult.cart);
            this.setState({ updating: false });
          })
          .catch(x => {
            this.setState({ updating: false });
          });
      })
      .catch(cargoChargesError => {
        this.setState({ updating: false });
      });
  }

  removeFromCart(cartItem: CartItem, showMessage: boolean = true) {

    this.handler.RemoveFromCart(cartItem.itemReference!).then(x => {
      this.setState({ isRemoved: true }, () => {
        this.props.updateCart(x.cart);
        if (showMessage) {
          // message.info('Item Removed from Cart.');
          NotificationUtility.info(
            'Item Removed',
            'Item was successfully removed from the cart.',
            25,
            true
          );
        }
      }
      );
    });
  }

  renderChargeItems(additionalInfo: string | undefined): React.ReactNode {
    if (!additionalInfo) {
      return <></>;
    }

    let cargeItem: CargesModel[];
    try {
      cargeItem = JSON.parse(additionalInfo);
    } catch (err) {
      return <></>;
    }

    const StyledTable = styled((props) => <Table {...props} />)`
    && tbody > tr > td {
      border-bottom: 0px solid #f0f0f0;
    }
  `;

    return (
      <StyledTable
        pagination={cargeItem.length > 3 && {}}
        dataSource={cargeItem}
        columns={this.chargeTableColums}
      />
    );
  }

  updateCartItemDate(newDate: Moment) {
    const cart = this.props.cartItem;
    cart.pickupDate = newDate.toISOString(true);
    this.UpdateCartItem(cart).then(x => {
      // message.success('Updated Pick-up date');
      NotificationUtility.info(
        'Updated Pick-up date',
        "Cart item's Pick-up date was successfully updated.",
        25,
        true
      );
    });
  }

  renderCurrentIcon() {
    // If you are updating then show a spinner
    if (this.state.updating) {
      return (
        <Tooltip title="Updating BOL Charges">
          <Icon type="sync" spin />
        </Tooltip>
      );
    }

    const updateDate = moment(this.props.cartItem.updateDate);
    // Now that you are finished updating, you either are upto date or something when wrong
    if (updateDate.isValid() && updateDate.isSameOrAfter(moment.now(), 'day')) {
      return (
        <Tooltip title="The charges have been updated for today">
          <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          title={
            <p>
              Charges may be different because this is not update.{' '}
              <a
                onClick={e =>
                  e.stopPropagation() == undefined &&
                  this.UpdateCartItemIfStale(this.props.cartItem)
                }>
                Refresh
              </a>
            </p>
          }>
          <Icon type="warning" theme="twoTone" twoToneColor="red" />
        </Tooltip>
      );
    }
  }

  render() {
    let cartItem = this.props.cartItem;
    return (
      <List.Item style={{ borderColor: '#808080' }} actions={[<Button onClick={() => this.removeFromCart(cartItem)} style={{ border: "0px" }} size="large"><Icon type="delete" theme="filled" style={{ color: "#FF6232" }} /></Button>]}>
        <List.Item.Meta
          style={{
            textAlign: 'left',
            backgroundColor: '#f8f8f8',
            borderRadius: '5px',
            overflow: 'hidden'
          }}
          title={cartItem.itemReference}
          description={
            <BorderlessCollapse bordered={false}>
              <Collapse.Panel
                key={cartItem.id!}
                header={
                  <Row type="flex" justify="space-between">
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 10, offset: 0 }}>
                      Pick-up Date: {Utility.ToDateString(moment.parseZone(cartItem.pickupDate))}
                      <CartItemChangeDateForm
                        currentDate={moment(cartItem.pickupDate)}
                        UpdatedDate={this.updateCartItemDate}
                      />
                    </Col>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 7, offset: 1 }}>
                      {cartItem.updateDate && Utility.ToDateString(moment(cartItem.updateDate))}
                      {this.renderCurrentIcon()}
                    </Col>
                    <Col
                      xs={{ span: 24, offset: 0 }}
                      sm={{ span: 6, offset: 0 }}
                      style={{ textAlign: 'right' }}>
                      JMD$ {cartItem.cost}
                    </Col>
                  </Row>
                }>
                {this.renderChargeItems(cartItem.additionalInfo)}
              </Collapse.Panel>
            </BorderlessCollapse>
          }
        />
      </List.Item>
    );
  }
}
